import { scalePoint } from 'd3-scale';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ChartCanvas from './../../../common/chart/lib/chart-canvas/ChartCanvas';
import { Chart } from 'react-stockcharts';
import { AreaSeries } from 'react-stockcharts/lib/series';
import { fitWidth } from 'react-stockcharts/lib/helper';
import { XAxis } from 'react-stockcharts/lib/axes';
import _ from 'lodash';
import {
  createVerticalLinearGradient,
  hexToRGBA,
} from 'react-stockcharts/lib/utils';
import './miniChart.scss';

class MiniAreaChart extends PureComponent {
  convertData = data => {
    const obj = {};
    let results = _.map(data, (item, index) => {
      obj.x = index - 1;
      obj.y = item * -1;
      return {
        y: item * -1,
        x: index,
      };
    });
    if (results && results.length === 1) {
      results = _.concat(obj, results);
    }
    return results;
  };

  render() {
    const { fill, data } = this.props;
    const canvasGradient = createVerticalLinearGradient([
      { stop: 0, color: hexToRGBA('#fff1d0', 0.2) },
      { stop: 0.7, color: hexToRGBA('#f8bc06', 0.4) },
      { stop: 1, color: hexToRGBA('#f8bc06', 0.8) },
    ]);
    const dataChart = this.convertData(data);
    let max;
    let min;
    dataChart.forEach(value => {
      max = max ? (value.y > max ? value.y : max) : value.y;
      min = min ? (value.y < min ? value.y : min) : value.y;
    });
    let yExtents = [min - 4, max];
    let width = 50;
    let height = 20;
    if (_.isEmpty(dataChart)) return null;
    return (
      <div className="mini-area-chart-wrapper">
        <ChartCanvas
          seriesName="miniAreaChart"
          ratio={window.devicePixelRatio}
          width={width}
          height={height}
          margin={{ left: 1, right: 1, top: 1, bottom: 1 }}
          data={dataChart}
          xAccessor={d => d.x}
          xExtents={list => list.map(d => d.x)}
          xScale={scalePoint()}
        >
          <Chart id={2} yExtents={yExtents} key={'keyChart42421'}>
            <defs>
              <linearGradient id="MyGradient" x1="0" y1="100%" x2="0" y2="0%">
                <stop offset="0%" stopColor="#fff1d0" stopOpacity={0.2} />
                <stop offset="70%" stopColor="#f8bc06" stopOpacity={0.4} />
                <stop offset="100%" stopColor="#f8bc06" stopOpacity={0.8} />
              </linearGradient>
            </defs>
            <XAxis
              axisAt="bottom"
              orient="bottom"
              stroke="#969696"
              showTicks={false}
              opacity={0.75}
            />
            <AreaSeries
              fill="url(#MyGradient)"
              yAccessor={d => d.y}
              strokeWidth={1}
              stroke={fill}
              canvasGradient={canvasGradient}
            />
          </Chart>
        </ChartCanvas>
      </div>
    );
  }
}

MiniAreaChart.propTypes = {
  data: PropTypes.array,
  seriesName: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  fill: PropTypes.string,
};

MiniAreaChart = fitWidth(MiniAreaChart);

MiniAreaChart.defaultProps = {
  data: [],
  seriesName: 'miniBarChart',
  width: 30,
  height: 10,
  fill: '#facc5c',
};

export default MiniAreaChart;
